import { PrayerTimes } from "../types/PrayerTypes";

// Timetable rows carry only a day-of-month ("Date"); there is no month/year per row.
// Consumers date each row by counting (today + index), so a list that starts on the wrong
// day or has a missing day silently mislabels every row after that point — which is how a
// Friday's JamDhuhr (the Jummah time) once surfaced as a Saturday Dhuhr change.
// Trim to today, then keep only the contiguous run, so the counting is always valid.
export function alignTimetablesToToday(
  rows: PrayerTimes[],
  now: Date = new Date(),
): PrayerTimes[] {
  if (!rows?.length) return rows;

  // Missing-timetable fallback rows use "--"; with nothing to align by, leave the list as-is.
  if (!rows.some((r) => Number.isFinite(parseInt(r.Date, 10)))) return rows;

  const start = rows.findIndex((r) => parseInt(r.Date, 10) === now.getDate());
  if (start < 0) return [];

  const aligned: PrayerTimes[] = [];
  for (let i = start; i < rows.length; i++) {
    const expected = new Date(now);
    expected.setDate(now.getDate() + (i - start));
    if (parseInt(rows[i].Date, 10) !== expected.getDate()) break;
    aligned.push(rows[i]);
  }

  return aligned;
}
